import { AgColor } from '../../../stories/Styles/AgColor';

export const contentStyle = {
  width: '100%',
  padding: '16px 24px 24px 24px',
  backgroundColor: AgColor.grey1,
  borderRadius: '8px',
  boxShadow: '0px 1px 2px 0px #0000000D',
};